import { render } from "./nhl_info_request_form_checkboxes.vue?vue&type=template&id=5a19e070"
import script from "./nhl_info_request_form_checkboxes.vue?vue&type=script&lang=js"
export * from "./nhl_info_request_form_checkboxes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__